import { render, staticRenderFns } from "./DepositsExtendedReport.component.vue?vue&type=template&id=02f5f4d4&scoped=true&"
import script from "./DepositsExtendedReport.component.vue?vue&type=script&lang=js&"
export * from "./DepositsExtendedReport.component.vue?vue&type=script&lang=js&"
import style0 from "./DepositsExtendedReport.component.vue?vue&type=style&index=0&id=02f5f4d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f5f4d4",
  null
  
)

export default component.exports